import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from 'react-router-dom';
import Preloader from '../src/components/Pre';
import Navbar from './components/Navbar';
import Home from './components/Home/Home';
import CharacterDesign from './components/CharacterDesign/CharacterDesign';
import GraphicStorytelling from './components/GraphicStorytelling/GraphicStorytelling';
import SoloExhibition from './components/SoloExhibition/SoloExhibition';
import DrawingMixedMedia from './components/DrawingMixedMedia/DrawingMixedMedia';
import Illustrations from './components/Illustrations/Illustrations';
import Footer from './components/Footer';
import Resume from './components/Resume/ResumeNew';
import Showreel from './components/Showreel/Showreel';
import ScrollToTop from './components/ScrollToTop';
import Modelling from './components/Modelling/Modelling';
import AboutMe from './components/AboutMe/AboutMe';
import './style.css';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? 'no-scroll' : 'scroll'}>
        <Navbar />
        <ScrollToTop />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/character-design" element={<CharacterDesign />} />
            <Route path="/graphic-storytelling" element={<GraphicStorytelling />} />
            <Route path="/solo-exhibition" element={<SoloExhibition />} />
            <Route path="/drawing-painting" element={<DrawingMixedMedia />} />
            <Route path="/illustrations" element={<Illustrations />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/showreel" element={<Showreel />} />
            <Route path="/about-me" element={<AboutMe />} />
            <Route path="/3d-modelling" element={<Modelling />} />
            <Route path="*" element={<Navigate to="/"/>} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
